// Used in view-assignment.component.html and grade-assignments.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

// Services/Types/Helpers
import {
    PPAssignment as Assignment,
    CompositeTaskAssignment,
} from "cli-types";
// Components
import { ActivityPreviewDialogComponent } from "#components/dialog-boxes/activity-preview-dialog/activity-preview-dialog.component";
import { Perform } from "@carnegie-learning/cure-types";

@Component({
    selector: "avenue-eval-student-video",
    templateUrl: "./avenue-eval-student-video.component.html",
    styleUrls: ["./avenue-eval-student-video.component.scss"],
    standalone: false
})
export class AvenueEvalStudentVideoComponent implements OnInit {
    avenueTask: Perform;
    isComposite = false;
    isStudent = true;
    // Temporary mock data for discussions, if needed.
    // discussions = [
    //     {author: 'John', comment: 'This is a great discussion!'},
    //     {author: 'Jane', comment: 'I agree'},
    //     {author: 'Marie', comment: 'Nice one'},
    //   ];

    @Input() assignment: Assignment | CompositeTaskAssignment;
    videoTitle = "";
    avenueDialogRef: MatDialogRef<ActivityPreviewDialogComponent> | null;

    constructor(public dialog: MatDialog, private router: Router) {}

    ngOnInit(): void {
        this.isStudent = this.router.url.includes("student");
        this.videoTitle = this.getVideoTitle(this.assignment);
        if (this.assignment.hasOwnProperty("compositeTask")) {
            const assnmnt = <CompositeTaskAssignment>this.assignment;
            this.avenueTask = <Perform>assnmnt.asset;
            this.isComposite = true;
        } else {
            const assnmnt = <Assignment>this.assignment;
            this.avenueTask = <Perform>assnmnt.asset;
        }
    }

    previewActivity() {
        if (!this.avenueTask && this.assignment.asset) {
            this.avenueTask = <Perform>this.assignment.asset;
        }
        if (this.avenueTask) {
            this.avenueDialogRef = this.dialog.open(
                ActivityPreviewDialogComponent,
                {
                    data: {
                        asset: this.avenueTask,
                        compositeID: null,
                        compositeType: null,
                    },
                }
            );
        }
    }

    getVideoTitle(assignment: Assignment | CompositeTaskAssignment) {
        return this.assignment.assignmentName;
    }
}
